import { ArrowRightBig, Calendar, Cart, Chat, Info, Offline } from '@shared/assets';

import type { Notification } from 'library/models/notifications';

export const getTitle = (notification: Notification) => {
	switch (notification.type) {
		case 'R':
			return 'Для вас есть новая рекомендация';

		case 'SA':
			return 'Специалист изменил запись на консультацию';

		case 'ST':
			return 'Клиент изменил запись на консультацию';

		case 'OR':
			return 'Информация о статусе заказа';

		case 'CL':
			return 'Вы записаны на приём';

		case 'CС':
			return 'У вас назначена личная консультация';

		case 'B':
			return 'Уведомление от системы reLife';

		case 'W':
			return 'Запись на вебинар';

		case 'A':
			return 'Получен ответ от специалиста';

		case 'Q':
			return 'Получен вопрос от клиента';

		case 'P':
			return 'Информация о статусе платежа';

		default:
			return 'Уведомление от системы reLife';
	}
};

export const getIcon = (notification: Notification) => {
	switch (notification.type) {
		case 'R':
			return ArrowRightBig;

		case 'SA':
			return Calendar;

		case 'ST':
			return Calendar;

		case 'OR':
			return Cart;

		case 'CL':
			return Offline;

		case 'CС':
			return Offline;

		case 'B':
			return Info;

		case 'W':
			return ArrowRightBig;

		case 'A':
			return Chat;
		case 'Q':
			return Chat;

		case 'P':
			return Cart;

		default:
			return Info;
	}
};
